export default __webpack_public_path__ + "static/media/world-tour.a4be511d.jpg";